const LangSignIn = {
  "signIn.signUp._notAMember": ["Not a member yet?", "Chưa là thành viên?"],
  "signIn.signUp._reward": [
    "Lorem ipsum dolor sit amet",
    "Lorem ipsum dolor sit amet"
  ],
  "signIn.signUp._description": [
    "<p>Join now! Membership is FREE, you'll receive 1 nut FREE upon signing up and...</p>",
    "<p>Đăng ký ngay!</p>"
  ],
  "signIn.form._forgotPasswordOrEmail": ["Forgot your password", "Quên "],
  "signIn.form._email": ["email", "email"],
  "signIn.form._password": ["password", "mật khẩu"],
  "signIn.form._invalidCredential": [
    "Please check your sign-in information and try again. 5 failed attempts before your account will be temporarily locked for 10 mins",
    "Địa chỉ email hoặc mật khẩu không đúng, vui lòng thử lại. Tài khoản của bạn sẽ bị tạm khóa trong vòng 10 phút nếu bạn nhập sai thông tin quá 5 lần."
  ],
  "signIn.signUp._pay": ["Pay with your phone", "Thanh toán với ứng dụng"],
  "signIn.signUp._earn": ["Earn free Drinks and Food", "Bánh và nước miễn phí"],
  "signIn.signUp._exclusive": ["Exclusive Member Offer", "Ưu đãi đặc biệt"]
  //"signIn.signUp._description": [`Register below`, `Register below`],
};

export default LangSignIn;



// WEBPACK FOOTER //
// ./src/resources/pages/LangSignIn.js